export default "__VITE_ASSET__80cf6c6b__"